import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { IUnitModel } from '../interfaces/models/units.interfaces'
import { useAuth } from './useAuth'
import { unitQueries } from '../api/units'

export const useManageHousehold = (): {
  enableHouseholdSettings: boolean
} => {
  const { userId } = useAuth()
  const [enableHouseholdSettings, setEnableHouseholdSettings] = useState(false)
  const { data: userUnits } = useQuery(unitQueries.getUserUnits(userId))

  const [selectedUnit, setSelectedUnit] = useState<IUnitModel | undefined>(
    userUnits && userUnits.length > 0 ? userUnits[0] : undefined
  )

  useEffect(() => {
    if (selectedUnit === undefined && userUnits && userUnits.length > 0) {
      setSelectedUnit(userUnits[0])
    }
  }, [selectedUnit, userUnits])

  useEffect(() => {
    if (userUnits && userUnits.length > 0 && !enableHouseholdSettings) {
      setEnableHouseholdSettings(true)
    }
  }, [userUnits, enableHouseholdSettings])

  return {
    enableHouseholdSettings,
  }
}
